import React from "react";
import { IconProps } from "../icon";

export const ArrowCircleBrokenLeftIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20.662 17A9.996 9.996 0 0112 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.996 9.996 0 018.662 5M12 8l-4 4m0 0l4 4m-4-4h14"
    />
  </svg>
);
